module.exports = {
      id: "xau-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#xau-usage",
      toString: function () {
        return this.url;
      }
    }